export default __webpack_public_path__ + "static/1351-a741a7147052835304cb996a6383c368.gif";